function TermsOfServicePage() {
  return (
    <div className="page">
      <h1 className="page-title">Terms of Service</h1>

      <div className="page-section">
        <p>
          These Terms of Service ("Terms") govern your access to and use of the software,
          websites, and services provided by Nuvolem Software Solutions ("Nuvolem", "Nuvolem LLC", "we",
          "us"). By installing, copying, accessing, or otherwise using our software or
          services, you agree to be bound by these Terms. If you do not agree, do not
          install or use them.
        </p>
        <p>
          <strong>License grant.</strong> Subject to these Terms, Nuvolem grants you a
          limited, non-exclusive, non-transferable, revocable license to install and use
          the software solely for your personal or internal business purposes, in
          accordance with these Terms, any accompanying documentation, and the seat terms
          associated with your order. You may not exceed the number of seats assigned to
          your organization.
        </p>
        <p>
          <strong>Restrictions.</strong> You may not:
        </p>
        <ul>
          <li>
            Reverse engineer, decompile, disassemble, or otherwise attempt to derive the
            source code of the software;
          </li>
          <li>
            Modify, adapt, translate, or create derivative works based on the software;
          </li>
          <li>
            Rent, lease, sell, sublicense, distribute, or otherwise transfer the software
            to any third party except as expressly permitted; or
          </li>
          <li>Use the software in any way that violates applicable laws or regulations.</li>
        </ul>
        <p>
          Any unauthorized use terminates the license granted under these Terms.
        </p>
        <p>
          <strong>Ownership.</strong> The software is licensed, not sold. All rights,
          title, and interest in and to the software, including any intellectual property
          rights, are and will remain the exclusive property of Nuvolem.
        </p>
        <p>
          <strong>Disclaimer.</strong> Except as expressly stated in any accompanying
          documentation, our software and services are provided "as is," without warranty
          of any kind, express or implied, including but not limited to warranties of
          merchantability, fitness for a particular purpose, and non-infringement.
        </p>
        <p>
          <strong>Limitation of liability.</strong> To the maximum extent permitted by
          law, in no event will Nuvolem or its affiliates be liable for any consequential,
          incidental, indirect, special, or punitive damages arising out of the use of or
          inability to use the software. Nuvolem's total liability under these Terms will
          not exceed the amount you paid for the software.
        </p>
        <p>
          <strong>Termination.</strong> These Terms are effective until terminated. Your
          rights will terminate automatically, without notice, if you fail to comply with
          any term. Upon termination, you must cease all use of the software and destroy
          all copies in your possession.
        </p>
        <p>
          <strong>Indemnification.</strong> You agree to indemnify, defend, and hold
          harmless Nuvolem and its officers, directors, employees, and affiliates from and
          against any claims, losses, damages, liabilities, and expenses (including
          reasonable attorneys' fees) arising out of or relating to your misuse of the
          software, your violation of these Terms, or your violation of any applicable law
          or the rights of any third party.
        </p>
        <p>
          <strong>Governing law.</strong> These Terms are governed by and construed in
          accordance with the laws of the State of Washington, without regard to its
          conflict of law principles.
        </p>
        <p>
          <strong>Changes.</strong> We may update these Terms from time to time. Continued
          use of our services after changes take effect constitutes acceptance of the
          revised Terms. These Terms constitute the entire agreement between you and
          Nuvolem concerning the software and supersede all prior understandings regarding
          that subject matter.
        </p>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
